import { Injectable } from '@angular/core';
import { HelperService } from './helper.service'; // Adjust according to your project
import { HTTPService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class WarrantyService {
  constructor(private httpService: HTTPService, private helperService: HelperService) { }

  async processUnassignedWarranties(
    id: string,
    data: any,
    serviceStatus: string,
    updateOrderCallback?: (updatedData: any) => void
  ) {
    if (!data) return;
    

    const warranties = this.helperService.getUnassignedWarrantyServiceItems(id, data, serviceStatus);

    if (Object.keys(warranties?.payload?.items).length > 0) {
      await this.fetchPartTypeIds(warranties?.payload?.items);
    }

    if (Object.keys(warranties?.payload?.items).length > 0) {
      await this.getCatalogItemDetails(warranties?.payload?.items);
    }

    const bulkWarranties:any = await this.httpService.checkWarrantyBulkServiceItems(warranties.payload);
    const unassignedWarranties = this.helperService.getUnassignedWarrantyServiceItems(id, data, serviceStatus, bulkWarranties);

    if (updateOrderCallback) {
      updateOrderCallback(unassignedWarranties);
    }

    return unassignedWarranties;
  }

  private async getCatalogItemDetails(items: any) {
    for (const key in items) {
      if (items.hasOwnProperty(key)) {
        const item = items[key];

        if (item.itemId) {
          try {
            const response: any = await this.httpService.getItemById(item.itemId);

            if (item?.itemType === 'part' && !item?.partTypeId) {
              item.partTypeId = response?.subSubCategory?.subSubCategoryId || null;
            }

            if (item?.itemType === 'tire' && !item?.partTypeId) {
              item.partTypeId = response?.tireType?.tireTypeId || null;
            }

            delete item.itemId;
          } catch (error) {
            console.error(`Error fetching partNumber ${item.partNumber}:`, error);
          }
        }
      }
    }
  }

  private async fetchPartTypeIds(items: any) {
    for (const key in items) {
      if (items.hasOwnProperty(key)) {
        const item = items[key];

        if (!item.partTypeId && item.partNumber) {
          try {
            const response: any = await this.httpService.getPartstechSearch(item.partNumber);
            delete item.partNumber;
            item.partTypeId = response?.data?.[0]?.subSubCategory?.subSubCategoryId || null;
          } catch (error) {
            console.error(`Error fetching partNumber ${item.partNumber}:`, error);
          }
        }
      }
    }
  }
}
